import { render, staticRenderFns } from "./ykylogin.vue?vue&type=template&id=48530fa6&scoped=true"
import script from "./ykylogin.vue?vue&type=script&lang=js"
export * from "./ykylogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48530fa6",
  null
  
)

export default component.exports